import React, { useState } from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
  Box,
  Paper,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    if (onSearch) {
      onSearch(searchTerm.trim());
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', my: 1 }}>
      <Paper
        elevation={2}
        sx={{
          display: 'flex',
          alignItems: 'center',
          borderRadius: '30px',
          padding: '8px 8px',
          width: '100%',
          maxWidth: 700,
          bgcolor: 'white',
        }}
      >
        <TextField
          fullWidth
          variant="standard"
          placeholder="Enter reference to search the status."
          value={searchTerm}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          InputProps={{
            disableUnderline: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleSearch}
                  edge="end"
                  sx={{
                    color: '#440252',
                    padding: '10px',
                    fontSize: '2rem',
                  }}
                  aria-label="search"
                >
                  <SearchIcon fontSize="inherit" />
                </IconButton>
              </InputAdornment>
            ),
            sx: {
              paddingLeft: 2,
              height: '30px',
              fontSize: '1.1rem',
            },
          }}
        />
      </Paper>
    </Box>
  );
};

export default SearchBar;
